//@flow
import * as React from 'react';
import DefaultErrorScreen from './ErrorScreen';
import errorBoundaryFactory, {
    type ErrorBoundaryOptionsType
} from './errorBoundaryFactory';

const DefaultErrorScreenComponent = ({
    t,
    actionUrl = '/',
    actionLabel = t('goToHomeScreen'),
    title = t('genericError'),
    subtitle = t('pleaseTryAgain')
}) => {
    return (
        <DefaultErrorScreen
            actionLabel={actionLabel}
            actionUrl={actionUrl}
            title={title}
            subtitle={subtitle}
        />
    );
};

const MinimalErrorScreen = ({
    t,
    error,
    title = t('genericError'),
    subtitle,
    actionUrl,
    actionLabel
}) => {
    return (
        <DefaultErrorScreen
            error={error}
            actionUrl={actionUrl}
            actionLabel={actionLabel}
            subtitle={subtitle}
            withIcon
            title={title}
            iconProps={{
                icon: 'alert',
                circular: true,
                wrapBgColor: 'salmon-two',
                invert: true,
                center: true
            }}
        />
    );
};

const withErrorBoundary = (
    {
        ErrorScreen = DefaultErrorScreenComponent,
        minimal = false,
        defaultProps = {},
        options = {}
    }: {
        ErrorScreen: React.ComponentType<*>,
        minimal?: boolean,
        defaultProps?: Object,
        options?: ErrorBoundaryOptionsType
    } = {
        ErrorScreen: DefaultErrorScreenComponent,
        minimal: false,
        defaultProps: {},
        options: {}
    }
) => (Component: React.ComponentType<*>) => {
    const ErrorScreenComponent = minimal ? MinimalErrorScreen : ErrorScreen;
    return errorBoundaryFactory({
        Component,
        ErrorScreen: ErrorScreenComponent,
        defaultProps,
        options
    });
};

const ErrorBoundary = withErrorBoundary()();
export { ErrorBoundary };
export default withErrorBoundary;
